import { useTranslate } from "@refinedev/core";
import { Button, Dialog, DialogActions, DialogTitle } from "@mui/material";

interface ConfirmDialogProps {
  open: boolean;
  onClose: (value: boolean) => void;
}

export const ConfirmDialog = ({ open, onClose }: ConfirmDialogProps) => {
  const translate = useTranslate();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {translate("buttons.confirm", "Are you sure?")}
      </DialogTitle>
      <DialogActions sx={{ justifyContent: "center" }}>
        <Button onClick={() => onClose(false)}>
          {translate("buttons.cancel", "Cancel")}
        </Button>
        <Button color="error" onClick={() => onClose(true)} autoFocus>
          {translate("buttons.delete", "Delete")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
